import React, { useState, useMemo, useEffect } from 'react';
import { shiftDateBy } from '@sparted/shared-library';
import { t } from 'i18next';

import { useDispatch } from 'react-redux';

import { NPSHeader } from '../NPSHeader/NPSHeader';
import { NPSStats } from '../NPSStats/NPSStats';

import { useModuleSelector, actions } from '../redux';

import styles from './NPSView.style';

const MIN_DAYS_BETWEEN_SCORES = 30;

export const NPSView = () => {
  const dispatch = useDispatch();

  const nbPromoters = useModuleSelector((state) => state.stats.nbPromoters);
  const nbPassives = useModuleSelector((state) => state.stats.nbPassives);
  const nbDetractors = useModuleSelector((state) => state.stats.nbDetractors);
  const nbPlayersExposed = useModuleSelector((state) => state.stats.nbPlayersExposed);
  const nbDaysBetweenScores = useModuleSelector((state) => {
    const nbDays = state.stats.nbDaysBetweenScores;
    if (!nbDays || nbDays === 0) return MIN_DAYS_BETWEEN_SCORES;
    return nbDays;
  });

  const currentScore = useModuleSelector((state) => state.stats.currentScore);
  const previousScore = useModuleSelector((state) => state.stats.previousScore);

  const [startDate, setStartDate] = useState<Date>(shiftDateBy({ days: -nbDaysBetweenScores }, new Date()));
  const [endDate, setEndDate] = useState<Date>(new Date());

  const differenceWithPreviousScore = useMemo(() => {
    if (currentScore === null || previousScore === null) return 0;

    return currentScore - previousScore;
  }, [previousScore, currentScore]);

  const handleDownloadReportClick = (startDate: Date, endDate: Date) => {
    dispatch(actions.getReport(startDate, endDate));
  };

  const total = nbPromoters + nbPassives + nbDetractors;

  useEffect(() => {
    dispatch(actions.getStats(startDate, endDate));
  }, [dispatch, startDate, endDate]);

  return (
    <div style={styles.container}>
      <NPSHeader
        nbAnswers={total}
        downloadButtonDisabled={currentScore === null}
        onDownloadReportClick={handleDownloadReportClick}
        nbPlayersExposed={nbPlayersExposed}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
      {currentScore === null && <div style={styles.noStatsMessage}>{t('analytics:nps.view.not_enough_data')}</div>}
      {currentScore !== null && (
        <NPSStats
          score={currentScore}
          differenceWithPreviousScore={differenceWithPreviousScore}
          nbDaysBetweenScores={nbDaysBetweenScores}
          nbPromoters={nbPromoters}
          nbPassives={nbPassives}
          nbDetractors={nbDetractors}
        />
      )}
    </div>
  );
};

export default NPSView;
